<template>
  <v-row>
    <v-col cols="12">
      <!-- Empty State -->
      <v-card v-if="questions.length === 0" class="my-4" max-width="70vw">
        <v-card-text class="text-center py-8">
          <v-icon size="64" color="primary" class="mb-4">mdi-clipboard-text-outline</v-icon>
          <h3 class="text-h5 mb-2">{{ $t("tripSurvey.noQuestions") }}</h3>
          <p class="text-body-1 mb-4">
            {{ $t("tripSurvey.noQuestionsDescription") }}
          </p>
          <v-btn color="primary" @click="addQuestion">
            {{ $t("tripSurvey.addQuestion") }}
          </v-btn>
        </v-card-text>
      </v-card>

      <!-- Question List -->
      <div class="question-list my-4" max-width="70vw">
        <v-card v-for="(element, index) in questions" :key="element.id" class="mb-4 question-card">
          <v-card-text>
            <div class="d-flex align-center">
              <div class="flex-grow-1">
                <v-text-field
                  v-model="element.title"
                  label="Question Title"
                  hide-details
                  class="mb-2"
                ></v-text-field>
                <v-text-field
                  v-model="element.description"
                  label="Question Description (Optional)"
                  hide-details
                  class="mb-2"
                ></v-text-field>

                <!-- Question Type Selector -->
                <v-select
                  v-model="element.type"
                  :items="questionTypes"
                  label="Question Type"
                  hide-details
                  class="mb-2"
                ></v-select>

                <!-- Type Specific Fields -->
                <v-text-field
                  v-if="element.type === 'openText'"
                  v-model="element.placeholder"
                  label="Answer Placeholder"
                  hide-details
                  class="mb-2"
                ></v-text-field>

                <!-- Question Preview -->
                <div class="mt-4">
                  <rating-question
                    v-if="element.type === 'rating'"
                    :title="element.title"
                    :description="element.description"
                  />
                  <open-text-question
                    v-else-if="element.type === 'openText'"
                    :title="element.title"
                    :description="element.description"
                    :placeholder="element.placeholder"
                  />
                </div>
                <v-btn icon color="error" @click="removeQuestion(index)" class="ml-2">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </div>

      <!-- Add Question Button -->
      <v-btn v-if="questions.length > 0" color="primary" block class="mt-4" @click="addQuestion">
        {{ $t("tripSurvey.addQuestion") }}
      </v-btn>

      <!-- Action Buttons -->
      <div class="d-flex mt-4 justify-end">
        <v-btn color="error" text class="mr-2" @click="$emit('cancel')">
          {{ $t("common.cancel") }}
        </v-btn>
        <v-btn color="primary" @click="saveSurvey" :disabled="!hasChanges">
          {{ $t("tripSurvey.saveSurvey") }}
        </v-btn>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import RatingQuestion from "./RatingQuestion.vue";
import OpenTextQuestion from "./OpenTextQuestion.vue";

export default {
  name: "TripSurvey",

  components: {
    RatingQuestion,
    OpenTextQuestion,
  },

  props: {
    initialQuestions: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      questions: [],
      hasChanges: false,
      questionTypes: [
        { text: "Star Rating", value: "rating" },
        { text: "Open Text", value: "openText" },
      ],
    };
  },

  created() {
    this.questions = JSON.parse(JSON.stringify(this.initialQuestions));
  },

  methods: {
    addQuestion() {
      this.questions.push({
        id: Date.now(), // Simple unique ID for draggable
        type: "rating",
        title: "",
        description: "",
        placeholder: "",
      });
      this.hasChanges = true;
    },

    removeQuestion(index) {
      this.questions.splice(index, 1);
      this.hasChanges = true;
    },

    saveSurvey() {
      this.$emit("save", this.questions);
    },
  },
};
</script>

<style scoped>
.question-list {
  min-height: 50px;
}

.question-card {
  transition: all 0.3s;
}
</style>
